import React from 'react';
import { Box, TextField, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({ searchTerm, setSearchTerm, handleSearch, currentView }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
      <TextField
        variant="outlined"
        placeholder={`Search ${currentView === 'interviews' ? 'interviews' : 'interviewees'}...`}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
        sx={{ width: '50%', marginRight: 2, marginBottom: 5 }}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSearch}
        startIcon={<SearchIcon />}
        sx={{ marginLeft: 2, marginBottom: 5 }}
      >
        Search
      </Button>
    </Box>
  );
};

export default SearchBar;
